import { render, staticRenderFns } from "./CardLiveTournament.vue?vue&type=template&id=24e67bf5&scoped=true"
import script from "./CardLiveTournament.js?vue&type=script&lang=js&external"
export * from "./CardLiveTournament.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e67bf5",
  null
  
)

export default component.exports